// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coffrets {
  overflow-x: hidden;
}

.coffrets .heroSkeleton,
.coffrets .hero {
  margin-top: unset !important;
}

.coffrets__container {
  margin-top: 2rem;
}

.coffrets__section {
  margin-bottom: 5rem;
  z-index: 1;
}

.coffrets__title {
  font-size: 1.5rem;
  color: var(--clr-gray800);
  white-space: nowrap;
  margin-bottom: 1rem;
}

.coffrets__contentContainerCoffret .cardSkeleton {
  width: 100%;
  max-width: unset;
  margin-right: 3rem;
  box-shadow: 0px 0.75rem 1rem rgba(0, 0, 0, 0.04);
  height: 20rem;
  border-radius: 1em;
}

.coffrets__container .swiper-container {
  margin: -2em;
}
.coffrets__container .swiper-wrapper {
  padding: 2em;
}

.coffrets__contentContainerPanier,
.coffrets__coffretsContainer {
  margin-top: 2rem;
  display: flex;
  gap: 3rem;
  overflow-x: scroll;
  padding: 2em;
  position: relative;
  overflow-y: hidden;
  margin: -2em;
  /* width: 100%; */
  scrollbar-width: none;
  /* grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr)); */
}

.coffrets__contentContainerPanier {
  padding-left: 4em;
  margin-left: -4rem;
}

.coffrets__mainTitle {
  margin-bottom: 1rem;
  color: var(--clr-gray800);
  font-size: 2rem;
}

.coffrets__section .coffrets__title {
  font-size: 1.75rem;
}

/* .coffrets__coffretsContainer::after {
  content: "";
  width: 2rem;
  height: 100%;
  background: linear-gradient(to left, #fffa, #fff0);
  position: absolute;
  right: -0.2rem;
} */

.coffrets__contentContainerPanier::-webkit-scrollbar,
.coffrets__coffretsContainer::-webkit-scrollbar {
  display: none;
}

.coffrets__sectionPanier,
.coffrets__section {
  position: relative;
}

.coffrets__sectionPanier {
  margin-bottom: 3rem;
}

.coffrets__sectionPanier::before,
.coffrets__sectionPanier::after,
.coffrets__section::before,
.coffrets__section::after {
  content: "";
  position: absolute;
  height: 100%;
  width: 5rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 4;
  pointer-events: none;
  display: none;
}

.coffrets__sectionPanier.max-left-side-panier::before,
.coffrets__sectionPanier.max-left-side-coffret::before,
.coffrets__section.max-left-side-panier::before,
.coffrets__section.max-left-side-coffret::before {
  right: -2rem;
  pointer-events: all;
  background: linear-gradient(270deg, #fcfbf9 0%, rgba(247, 247, 252, 0) 100%);
}

.coffrets__sectionPanier.max-right-side-panier::after,
.coffrets__sectionPanier.max-right-side-coffret::after,
.coffrets__section.max-right-side-panier::after,
.coffrets__section.max-right-side-coffret::after {
  pointer-events: all;
  left: -2rem;
  background: linear-gradient(-270deg, #fcfbf9 0%, rgba(247, 247, 252, 0) 100%);
}

.coffrets__chevron {
  position: absolute;
  width: 3rem;
  top: 50%;
  cursor: pointer;
  z-index: 6;
  transform: translateY(-50%);
  display: none;
}

.coffrets__chevron.show {
  display: initial;
}

.coffrets__chevron.right {
  /* right: -0.5rem; */
  right: -2.75rem;
}
.coffrets__chevron.left {
  /* left: -0.5rem; */
  left: -2.5rem;
}

@media (min-width: 475px) {
  .coffrets__sectionPanier::before,
  .coffrets__sectionPanier::after,
  .coffrets__section::before,
  .coffrets__section::after {
    width: 8rem;
  }

  .coffrets__chevron {
    width: 5.33rem;
  }
}

@media (min-width: 375px) {
  .coffrets__title {
    font-size: 1.8rem;
  }
}

@media (min-width: 768px) {
  .coffrets__container {
    margin-top: 3rem;
  }
  .coffrets__title {
    font-size: 2rem;
  }

  /* .coffrets__coffretsContainer {
    grid-template-columns: repeat(100%, minmax(100%, 1fr));
  } */
}

@media (min-width: 992px) {
  .coffrets__chevron.left {
    /* left: -0.5rem; */
    left: -4.5rem;
  }

  .coffrets {
    overflow-x: unset;
  }

  .coffrets__chevron.right {
    /* right: -0.5rem; */
    right: -5.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Coffrets/Coffrets.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,iEAAiE;AACnE;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;GAOG;;AAEH;;EAEE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;EACpB,aAAa;AACf;;AAEA;;;;EAIE,YAAY;EACZ,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;;;;EAIE,mBAAmB;EACnB,WAAW;EACX,6EAA6E;AAC/E;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,eAAe;EACf,UAAU;EACV,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;;;;IAIE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;;EAEA;;KAEG;AACL;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,cAAc;EAChB;AACF","sourcesContent":[".coffrets {\n  overflow-x: hidden;\n}\n\n.coffrets .heroSkeleton,\n.coffrets .hero {\n  margin-top: unset !important;\n}\n\n.coffrets__container {\n  margin-top: 2rem;\n}\n\n.coffrets__section {\n  margin-bottom: 5rem;\n  z-index: 1;\n}\n\n.coffrets__title {\n  font-size: 1.5rem;\n  color: var(--clr-gray800);\n  white-space: nowrap;\n  margin-bottom: 1rem;\n}\n\n.coffrets__contentContainerCoffret .cardSkeleton {\n  width: 100%;\n  max-width: unset;\n  margin-right: 3rem;\n  box-shadow: 0px 0.75rem 1rem rgba(0, 0, 0, 0.04);\n  height: 20rem;\n  border-radius: 1em;\n}\n\n.coffrets__container .swiper-container {\n  margin: -2em;\n}\n.coffrets__container .swiper-wrapper {\n  padding: 2em;\n}\n\n.coffrets__contentContainerPanier,\n.coffrets__coffretsContainer {\n  margin-top: 2rem;\n  display: flex;\n  gap: 3rem;\n  overflow-x: scroll;\n  padding: 2em;\n  position: relative;\n  overflow-y: hidden;\n  margin: -2em;\n  /* width: 100%; */\n  scrollbar-width: none;\n  /* grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr)); */\n}\n\n.coffrets__contentContainerPanier {\n  padding-left: 4em;\n  margin-left: -4rem;\n}\n\n.coffrets__mainTitle {\n  margin-bottom: 1rem;\n  color: var(--clr-gray800);\n  font-size: 2rem;\n}\n\n.coffrets__section .coffrets__title {\n  font-size: 1.75rem;\n}\n\n/* .coffrets__coffretsContainer::after {\n  content: \"\";\n  width: 2rem;\n  height: 100%;\n  background: linear-gradient(to left, #fffa, #fff0);\n  position: absolute;\n  right: -0.2rem;\n} */\n\n.coffrets__contentContainerPanier::-webkit-scrollbar,\n.coffrets__coffretsContainer::-webkit-scrollbar {\n  display: none;\n}\n\n.coffrets__sectionPanier,\n.coffrets__section {\n  position: relative;\n}\n\n.coffrets__sectionPanier {\n  margin-bottom: 3rem;\n}\n\n.coffrets__sectionPanier::before,\n.coffrets__sectionPanier::after,\n.coffrets__section::before,\n.coffrets__section::after {\n  content: \"\";\n  position: absolute;\n  height: 100%;\n  width: 5rem;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 4;\n  pointer-events: none;\n  display: none;\n}\n\n.coffrets__sectionPanier.max-left-side-panier::before,\n.coffrets__sectionPanier.max-left-side-coffret::before,\n.coffrets__section.max-left-side-panier::before,\n.coffrets__section.max-left-side-coffret::before {\n  right: -2rem;\n  pointer-events: all;\n  background: linear-gradient(270deg, #fcfbf9 0%, rgba(247, 247, 252, 0) 100%);\n}\n\n.coffrets__sectionPanier.max-right-side-panier::after,\n.coffrets__sectionPanier.max-right-side-coffret::after,\n.coffrets__section.max-right-side-panier::after,\n.coffrets__section.max-right-side-coffret::after {\n  pointer-events: all;\n  left: -2rem;\n  background: linear-gradient(-270deg, #fcfbf9 0%, rgba(247, 247, 252, 0) 100%);\n}\n\n.coffrets__chevron {\n  position: absolute;\n  width: 3rem;\n  top: 50%;\n  cursor: pointer;\n  z-index: 6;\n  transform: translateY(-50%);\n  display: none;\n}\n\n.coffrets__chevron.show {\n  display: initial;\n}\n\n.coffrets__chevron.right {\n  /* right: -0.5rem; */\n  right: -2.75rem;\n}\n.coffrets__chevron.left {\n  /* left: -0.5rem; */\n  left: -2.5rem;\n}\n\n@media (min-width: 475px) {\n  .coffrets__sectionPanier::before,\n  .coffrets__sectionPanier::after,\n  .coffrets__section::before,\n  .coffrets__section::after {\n    width: 8rem;\n  }\n\n  .coffrets__chevron {\n    width: 5.33rem;\n  }\n}\n\n@media (min-width: 375px) {\n  .coffrets__title {\n    font-size: 1.8rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .coffrets__container {\n    margin-top: 3rem;\n  }\n  .coffrets__title {\n    font-size: 2rem;\n  }\n\n  /* .coffrets__coffretsContainer {\n    grid-template-columns: repeat(100%, minmax(100%, 1fr));\n  } */\n}\n\n@media (min-width: 992px) {\n  .coffrets__chevron.left {\n    /* left: -0.5rem; */\n    left: -4.5rem;\n  }\n\n  .coffrets {\n    overflow-x: unset;\n  }\n\n  .coffrets__chevron.right {\n    /* right: -0.5rem; */\n    right: -5.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
